module.exports = __webpack_public_path__ + "static/media/partner-08.aa9542bc.jpg";